
import { Injectable, ErrorHandler } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { AlertService, MessageSeverity } from './services/alert.service';


@Injectable()
export class AppErrorHandler extends ErrorHandler {

    //private alertService: AlertService;

    constructor() {
        super();
    }


    handleError(error: any) {
        //if (this.alertService == null) {
        //    this.alertService = this.injector.get(AlertService);
        //}

        //this.alertService.showStickyMessage("Fatal Error!", "An unresolved error has occured. Please reload the page to correct this error", MessageSeverity.warn);
        //this.alertService.showStickyMessage("Unhandled Error", error.message || error, MessageSeverity.error, error);

        // 401/403 specifically - and only these two - are already fully handled elsewhere:
        // JwtInterceptor's own logic runs on every single request in the app and already
        // does auth.logout() + auth.redirectLogoutUser() (401) or redirectForUnAuthorized()
        // (403) before this ever gets here, independent of whether the calling component's
        // own .subscribe() has an error callback. So the confirm()/reload prompt was never
        // the only recovery path for these two - it was just a redundant, blocking popup on
        // top of a redirect that already happens automatically (found 2026-09-27: a routine,
        // already-harmless pre-login 401 - a component fetching data before the user had
        // logged in - was popping this dialog, forcing it to be dismissed before the user
        // could even log in).
        // Deliberately NOT widened to every HttpErrorResponse: a genuine 500 or a real
        // network failure on one of this codebase's many .subscribe(response => {...}) calls
        // with no error callback of its own may currently have no other user-facing signal
        // that something broke - suppressing the popup for those too would trade one bad UX
        // for a worse, silent one. Only 401/403 are provably redundant with existing recovery.
        if (error instanceof HttpErrorResponse && (error.status === 401 || error.status === 403)) {
            super.handleError(error);
            return;
        }

        if (confirm("Fatal Error!\nAn unresolved error has occured. Do you want to reload the page to correct this?\n\nError: " + error.message))
            window.location.reload(true);

        super.handleError(error);
    }
}
